import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Container, Toast, ToastBody, ToastHeader } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  useDeletePermissionMutation,
  useLazyGetPermissionListQuery,
} from "store/api/permissions/permissions.api"
import TableContainer from "components/Common/TableContainer"
import CreatePermissionModal from "modals/createPermissionModal"
import avatar from "../../assets/images/avatar.png"
import arrowDown from "../../assets/images/icons/arrow-down.svg"
import eye from "../../assets/images/icons/eye.svg"
import edit from "../../assets/images/icons/edit.svg"
import deleteIcon from "../../assets/images/icons/delete-red.svg"
import { Link } from "react-router-dom"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const ExportTransactionHistory = () => {
  const [trigger] = useLazyGetPermissionListQuery()
  const [open, setOpen] = useState(false)
  const [mutate] = useDeletePermissionMutation()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([
    {
      name: "Rajat Bansal",
      email: "rajat.bansal@prachay.in",
      Investor: "ICDR1001",
      Amount: "₹5,00,000",
      roi: "9.25%",
      Date: "9.25%",
      ICDValue: "12 mo",
    },
    {
      name: "Neha Kapoor",
      email: "neha.kapoor@prachay.in",
      Investor: "ICDR1001",
      Amount: "₹5,00,000",
      roi: "9.20%",
      Date: "9.25%",
      ICDValue: "12 mo",
    },
    {
      name: "Arvind Chauhan",
      email: "arvind.ch@capitalrise.in",
      Investor: "ICDR1001",
      Amount: "₹5,00,000",
      roi: "6.05%",
      Date: "9.25%",
      ICDValue: "12 mo",
    },
    {
      name: "Arvind Chauhan",
      email: "arvind.ch@capitalrise.in",
      Investor: "ICDR1001",
      Amount: "₹5,00,000",
      roi: "9.25%",
      Date: "9.25%",
      ICDValue: "12 mo",
    },
  ])
  const [isToast, setIsToast] = useState(false)
  const deleteRef = useRef(null)
  const [editDetails, setEditdetails] = useState(null)
  //meta title
  document.title = "Wealth Partner List"

  const getList = async () => {
    try {
      const { data } = await trigger().unwrap()
      // setData()
    } catch (error) {}
  }

  useEffect(() => {
    getList()
  }, [])

  const onDeletePermission = async () => {
    const data = deleteRef?.current
    if (data) {
      try {
        const res = await mutate(data)
        if (res.data.success) {
          deleteRef.current = null
          getList()
          setIsToast(false)
        }
      } catch (error) {}
    }
  }

  const handleUserClick = () => {
    setOpen(true)
    setEditdetails(null)
  }

  const refreshData = () => {
    getList()
    setOpen(false)
  }

  const columns = useMemo(
    () => [
      {
        header: "Investor Detail",
        accessorKey: "bond",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            email={row?.original.email}
            name={row?.original.name}
          />
        ),
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Investor ID <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Investor",
        enableColumnFilter: false,
        enableSorting: true,

        cell: ({ row }) => (
          <div className="code-number">{row?.original.Investor}</div>
        ),
      },

      {
        header: () => (
          <div className="flex items-center gap-2">
            Amount (₹) <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Amount",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            ROI <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "roi",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Date <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            ICD Value <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "ICDValue",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        id: "action",
        header: "",
        cell: ({ row }) => (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="action-view">
              <Link to={"#"}>
                <img src={eye} alt="" />
              </Link>
            </div>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Track Total Funds Raised"}
            breadcrumbItem={"Track Total Funds Raised"}
          />
          <TableContainer
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            buttonName={"Invite"}
            isGlobalFilter={true}
            isCustomPageSize={true}
            handleUserClick={handleUserClick}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
          {open && (
            <CreatePermissionModal
              open={open}
              title={!editDetails ? "Create" : "Edit"}
              setOpen={setOpen}
              refreshData={refreshData}
              editData={editDetails}
            />
          )}
        </Container>

        {isToast && (
          <div
            className="position-fixed top-0 start-50 translate-middle-x p-3"
            style={{ zIndex: "1005" }}
          >
            <Toast isOpen={isToast} role="alert">
              <ToastBody>
                Are you sure you want to delete this permission?
                <div className="mt-2 pt-2 border-top">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm me-1"
                    onClick={onDeletePermission}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setIsToast(false)
                      deleteRef.current = null
                    }}
                    type="button"
                    className="btn btn-secondary btn-sm"
                  >
                    No
                  </button>
                </div>
              </ToastBody>
            </Toast>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default ExportTransactionHistory
